module.exports = __webpack_public_path__ + "public/images/about-netw-desktop.1249649281d45c1036504bc6fabc09ad.svg";